import { useSelector } from 'react-redux';
import useAnalyticsLogActions from './_actions';

export const useAnalyticsLog = () => {
    const {
        fetchLogList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate,
    } = useAnalyticsLogActions();

    const logs = useSelector(state => state.analyticslog.data);
    const currentPage = useSelector(state => state.analyticslog.currentPage);
    const totalRows = useSelector(state => state.analyticslog.totalRows);
    const rowsPerPage = useSelector(state => state.analyticslog.rowsPerPage);
    const isLoading = useSelector(state => state.analyticslog.isLoading);
    const isError = useSelector(state => state.analyticslog.isError);
    const errorMessage = useSelector(state => state.analyticslog.errorMessage);
    const searchTerm = useSelector(state => state.analyticslog.searchTerm);
    const userType = useSelector(state => state.analyticslog.userType);
    const start_date = useSelector(state => state.analyticslog.start_date);
    const end_date = useSelector(state => state.analyticslog.end_date);
    
    return {
        logs,
        currentPage,
        totalRows,
        rowsPerPage,
        isLoading,
        isError,
        errorMessage,
        searchTerm,
        userType,
        start_date,
        end_date,

        fetchLogList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate
    }
}

export { default as analyticsLogReducer } from './_reducers';